import { createTheme } from '@material-ui/core/styles';

// Blue Theme (Default)
export const blueTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Material-UI default blue
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#dc004e',
      light: '#ff5983',
      dark: '#9a0036',
      contrastText: '#ffffff',
    },
  },
  name: 'blue',
  displayName: 'Blue Theme',
});

// Green Theme (YubiKey Style)
export const greenTheme = createTheme({
  palette: {
    primary: {
      main: '#4caf50', // Material-UI green
      light: '#81c784',
      dark: '#388e3c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
      contrastText: '#ffffff',
    },
  },
  name: 'green',
  displayName: 'Green Theme',
});

// Purple Theme (Optional)
export const purpleTheme = createTheme({
  palette: {
    primary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      light: '#ff5983',
      dark: '#c51162',
      contrastText: '#ffffff',
    },
  },
  name: 'purple',
  displayName: 'Purple Theme',
});

// 红色主题（可选）
export const redTheme = createTheme({
  palette: {
    primary: {
      main: '#f44336',
      light: '#e57373',
      dark: '#d32f2f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ff9800',
      light: '#ffb74d',
      dark: '#f57c00',
      contrastText: '#ffffff',
    },
  },
  name: 'red',
  displayName: 'Red Theme',
});

// 主题工厂函数 - 确保每次返回新的主题对象
export const createCustomTheme = (themeName) => {
  switch (themeName) {
    case 'blue':
      return createTheme({
        palette: {
          primary: {
            main: '#1976d2',
            light: '#42a5f5',
            dark: '#1565c0',
            contrastText: '#ffffff',
          },
          secondary: {
            main: '#dc004e',
            light: '#ff5983',
            dark: '#9a0036',
            contrastText: '#ffffff',
          },
        },
        name: 'blue',
        displayName: 'Blue Theme',
      });
    case 'green':
      return createTheme({
        palette: {
          primary: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c',
            contrastText: '#ffffff',
          },
          secondary: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: '#ffffff',
          },
        },
        name: 'green',
        displayName: 'Green Theme',
      });
    case 'purple':
      return createTheme({
        palette: {
          primary: {
            main: '#9c27b0',
            light: '#ba68c8',
            dark: '#7b1fa2',
            contrastText: '#ffffff',
          },
          secondary: {
            main: '#f50057',
            light: '#ff5983',
            dark: '#c51162',
            contrastText: '#ffffff',
          },
        },
        name: 'purple',
        displayName: 'Purple Theme',
      });
    case 'red':
      return createTheme({
        palette: {
          primary: {
            main: '#f44336',
            light: '#e57373',
            dark: '#d32f2f',
            contrastText: '#ffffff',
          },
          secondary: {
            main: '#ff9800',
            light: '#ffb74d',
            dark: '#f57c00',
            contrastText: '#ffffff',
          },
        },
        name: 'red',
        displayName: 'Red Theme',
      });
    default:
      return createTheme({
        palette: {
          primary: {
            main: '#1976d2',
            light: '#42a5f5',
            dark: '#1565c0',
            contrastText: '#ffffff',
          },
          secondary: {
            main: '#dc004e',
            light: '#ff5983',
            dark: '#9a0036',
            contrastText: '#ffffff',
          },
        },
        name: 'blue',
        displayName: 'Blue Theme',
      });
  }
};

// 所有可用主题名称
export const availableThemeNames = ['blue', 'green', 'purple', 'red'];

// Get theme display name
export const getThemeDisplayName = (themeName) => {
  const displayNames = {
    blue: 'Blue Theme',
    green: 'Green Theme',
    purple: 'Purple Theme',
    red: 'Red Theme',
  };
  return displayNames[themeName] || 'Blue Theme';
};

// Get saved theme from localStorage
export const getSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem('canokey-theme');
    return savedTheme && availableThemeNames.includes(savedTheme) ? savedTheme : 'blue';
  } catch (error) {
    return 'blue';
  }
};

// Save theme to localStorage
export const saveTheme = (themeName) => {
  try {
    localStorage.setItem('canokey-theme', themeName);
  } catch (error) {
    console.warn('Unable to save theme settings to localStorage:', error);
  }
}; 